import { $http } from "../config"

const RecycledDrafts = {
  getAllRecycledDrafts: () => $http("/recycled-drafts").then(res => res.data),
  getRecycledDraftById: id => $http(`/recycled-drafts/${id}`).then(res => res.data),
  deleteRecycledDraftById: id => $http.delete(`/recycled-drafts/${id}`).then(res => res.data)
}

export default RecycledDrafts
